export default __webpack_public_path__ + "media/create-game2x.5e6d7287.png";